import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import Header from '../Components/HeaderAdmin'; // Import Header
import {
    MDBBadge,
    MDBTable,
    MDBTableHead,
    MDBTableBody,
    MDBCol,
    MDBContainer,
    MDBRow,
    MDBCard,
    MDBCardBody,
    MDBBtn // Import MDBBtn for the Edit button
} from 'mdb-react-ui-kit';
import { BASE_URL } from '../config';

export default function DoctorSechdulelist() {
    const [DoctorSchedule, setDoctorSchedule] = useState([]);
    const navigate = useNavigate(); // Initialize navigate function for routing

    useEffect(() => {
        const fetchDoctorRequests = async () => {
            try {
                const response = await fetch(`${BASE_URL}DoctorSchedule`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'text/plain',
                    },
                });

                // if (!response.ok) {
                //     throw new Error('Network response was not ok');
                // }

                const data = await response.json();
                // Update to access the correct property
                if (response.ok) {
                    setDoctorSchedule(data.getSpecialistScheduleDetail);
                }
                else {
                    alert(data.message);

                }
            } catch (error) {
                console.error('Error fetching doctor requests:', error);
            }
        };

        fetchDoctorRequests();
    }, []);

    // Handle the edit button click to navigate to the edit page with the ScheduleId
    const handleEditClick = (scheduleId) => {
        navigate(`/editDoctorSchedule/${scheduleId}`); // Navigate to the edit page with the ScheduleId
    };

    return (
        <MDBContainer fluid className='h-custom py-1'>
            <MDBRow className='d-flex justify-content-center align-items-center h-50 m-3'>
                <MDBRow>
                    <Header />
                    {/* Use Header component */}
                </MDBRow>
                <MDBCol col='12' className="mt-3">
                    <MDBCard className='card-registration card-registration-2' style={{ borderRadius: '15px' }}>
                        <MDBCardBody className='p-0'>
                            <MDBTable align='middle'>
                                <MDBTableHead>
                                    <tr>
                                        <th scope='col'>Doctor Name</th>
                                        <th scope='col'>Status</th>
                                        <th scope='col'>Start Time</th>
                                        <th scope='col'>End Time</th>
                                        <th scope='col'>Day Of Week</th>
                                        <th scope='col'>Create Time</th>
                                        <th scope='col'>Actions</th> {/* Added actions column */}
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    {DoctorSchedule.map((schedule, index) => (
                                        <tr key={index}>
                                            <td>
                                                <p className='fw-normal mb-1'>{schedule.doctorName || 'N/A'}</p>
                                            </td>
                                            <td>
                                                <MDBBadge color={schedule.status === "Active" ? 'success' : 'danger'} pill>
                                                    {schedule.status}
                                                </MDBBadge>
                                            </td>
                                            <td>
                                                <p className='fw-normal mb-1'>{schedule.startTime || 'N/A'}</p>
                                            </td>
                                            <td>
                                                <p className='fw-normal mb-1'>{schedule.endTime || 'N/A'}</p>
                                            </td>
                                            <td>
                                                <p className='fw-normal mb-1'>{schedule.dayofweek || 'N/A'}</p>
                                            </td>
                                            <td>
                                                <p className='fw-normal mb-1'>{schedule.createtime || 'N/A'}</p>
                                            </td>
                                            <td>
                                                {/* Edit button */}
                                                <MDBBtn
                                                    size="sm"
                                                    color="primary"
                                                    onClick={() => handleEditClick(schedule.id)}
                                                >
                                                    Edit
                                                </MDBBtn>
                                            </td>
                                        </tr>
                                    ))}
                                </MDBTableBody>
                            </MDBTable>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
}
